<template>
  <div class="container-item story">  
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-12">
        <div class="storytelling d-md-none d-block">
          <span class="line"></span>
          <h3>{{ cardText.year }}</h3>
        </div>
        <div>
          <img :src="cardText.imageBg" alt="dd">
        </div>
        <div v-if="cardText.imageCredits" class="text-left creditos-picture mb-3">
          {{ $t('creditos.label_creditos') }}: {{ cardText.imageCredits }}
        </div>
      </div>
      <div class="col-md-4 col-lg-3 col-12 align-self-center">
        <div class="storytelling">
          <div class="d-none d-md-block">
            <span class="line"></span>
            <h3 class="mb-3">{{ cardText.year }}</h3>
          </div>
          <div>
            <p>{{ cardText.text }}
            </p>
          </div>
        </div>
      </div>
    </div>    
  </div>
</template>


<script>

export default {
  name: 'SingleCard',
  props: {
    cardText: Object 
  }
}
</script>